import { css } from '@emotion/react';
import React from 'react';
import { getUserColour } from '@birdi/utils';
import { v5 } from 'uuid';

export interface AvatarBaseProps {
  colour: string;
  label: string;
  profilePic?: string | null;
  fallbackContent: string;
}

export const AvatarBase = ({
  colour,
  label,
  profilePic,
  fallbackContent,
}: AvatarBaseProps) => (
  <div
    css={css`
      display: flex;
      background: ${colour};
      width: 32px;
      height: 32px;
      align-items: center;
      justify-content: center;
      text-align: center;
      overflow: hidden;
      border-radius: 100px;
      color: white;
      font-weight: 700;
      cursor: inherit;
      user-select: none;
      position: relative;
    `}
    aria-label={label}
    title={label}
  >
    {profilePic ? (
      <img
        src={profilePic}
        alt=""
        css={css`
          width: 100%;
          height: 100%;
        `}
      />
    ) : (
      fallbackContent
    )}
  </div>
);

interface CommonAvatarProps {
  profilePic?: string | null;
  name: string;
  isSelf?: boolean;
}

export interface IdAvatarProps extends CommonAvatarProps {
  id: string;
}

export interface EmailAvatarProps extends CommonAvatarProps {
  email: string;
}

export type AvatarProps = IdAvatarProps | EmailAvatarProps;

const uuidFromEmail = (email: string) =>
  v5(email, '84a60369-3e2b-46a3-a5e1-72cf8a839c6b');

export const Avatar = ({ profilePic, name, isSelf, ...props }: AvatarProps) => {
  const id = 'id' in props ? props.id : uuidFromEmail(props.email);
  return (
    <AvatarBase
      colour={getUserColour(id)}
      label={`${name}${isSelf ? ' (you)' : ''}`}
      fallbackContent={name[0].toUpperCase()}
      profilePic={profilePic}
    />
  );
};
